// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../k8-opt-exec-ST-a828a81199fe/bin/redo/shopify/extension/webpack.bin.runfiles/npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../k8-opt-exec-ST-a828a81199fe/bin/redo/shopify/extension/webpack.bin.runfiles/npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._2d-0 {\n  padding-left: 0px !important;\n  overflow: hidden;\n}\n", ""]);
// Exports
export var phoneNumberInput = "_2d-0";
export default ___CSS_LOADER_EXPORT___;
